<app-header-style-two></app-header-style-two>

<div class="shop-area ptb-100">
    <div class="container">


        <div class="row ">

            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <p class="playfair-display" style="    font-size: 40px;
                color: white;">{{aboutUsPages?.title}}</p>
                    <p [innerHtml]="aboutUsPages?.shortText" style="    
                    color: white;">
                    </p>

                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img [src]="createImgPath(aboutUsPages?.img1)" class="shadow">
                </div>
            </div>
        </div>
        <div class="row ">
            <p [innerHtml]="aboutUsPages?.fullText" style="    
            color: white;">
            </p>
        </div>

        <br>

    </div>
</div>